import {
    FETCH_PATIENTS_REQUEST,
    FETCH_PATIENTS_SUCCESS,
    FETCH_PATIENTS_FAILURE,
    FETCH_PATIENTS_COUNT_REQUEST,
    FETCH_PATIENTS_COUNT_SUCCESS,
    FETCH_PATIENTS_COUNT_FAILURE,
    SET_SELECTED_PATIENT,
    CLEAR_SELECTED_PATIENT,
    FETCH_PATIENTPRESCRLIST_REQUEST,
    FETCH_PATIENTPRESCRLIST_SUCCESS,
    FETCH_PATIENTPRESCRLIST_FAILURE,
    FETCH_PATIENTLABTESTSLIST_REQUEST,
    FETCH_PATIENTLABTESTSLIST_SUCCESS,
    FETCH_PATIENTLABTESTSLIST_FAILURE,
    SET_PATIENTREGISTRATION_PAYLOAD,
    CLEAR_PATIENTREGISTRATION_PAYLOAD,
    SET_SELECTEDEDIT_PATIENT,
    CLEAR_SELECTEDEDIT_PATIENT,
    PATIENT_FILTER_ENABLED,
    PATIENT_FILTER_CLEAR,
    FETCH_PATIENTSTETHESCOPE_REPORTS_REQUEST,
    FETCH_PATIENTSTETHESCOPE_REPORTS_SUCCESS,
    FETCH_PATIENTSTETHESCOPE_REPORTS_FAILURE,
    FETCH_FAMILYMEMBERS_REQUEST,
    FETCH_FAMILYMEMBERS_SUCCESS,
    FETCH_FAMILYMEMBERS_FAILURE,
    FETCH_FAMILYMEMBERS_COUNT_REQUEST,
    FETCH_FAMILYMEMBERS_COUNT_SUCCESS,
    FETCH_FAMILYMEMBERS_COUNT_FAILURE,
    CLEAR_FAMILY_MEMBERS
} from "../actions/patientActions";

const initialState = {
    patientsList: [],
    familyMembers:[],
    prescriptionsList:[],
    labTestsList:[],
    selectedPatient: null,
    selectedEditPatient:null,
    registrationPayload:null,
    totalCount: 0,
    familyMemberCount:0,
    isLoading: false,
    countLoading:false,
    error: null,
    patientFilter:false,
    stethReportList:[],
    stethLoader:false,
};


export const patientsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PATIENTS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_PATIENTS_SUCCESS:
            return { ...state, patientsList: action.payload, isLoading: false };

        case FETCH_PATIENTS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

         case FETCH_FAMILYMEMBERS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_FAMILYMEMBERS_SUCCESS:
            return { ...state, familyMembers: action.payload, isLoading: false };

        case FETCH_FAMILYMEMBERS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_PATIENTS_COUNT_REQUEST:
            return { ...state, countLoading: true };

        case FETCH_PATIENTS_COUNT_SUCCESS:
            return { ...state, totalCount: action.payload, countLoading: false };

        case FETCH_PATIENTS_COUNT_FAILURE:
            return { ...state, error: action.payload, countLoading: false };

        case FETCH_FAMILYMEMBERS_COUNT_REQUEST:
            return { ...state, countLoading: true };

        case FETCH_FAMILYMEMBERS_COUNT_SUCCESS:
            return { ...state, familyMemberCount: action.payload, countLoading: false };

        case FETCH_FAMILYMEMBERS_COUNT_FAILURE:
            return { ...state, error: action.payload, countLoading: false };

        case FETCH_PATIENTPRESCRLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_PATIENTPRESCRLIST_SUCCESS:
            return { ...state, prescriptionsList: action.payload, isLoading: false };

        case FETCH_PATIENTPRESCRLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_PATIENTLABTESTSLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_PATIENTLABTESTSLIST_SUCCESS:
            return { ...state, labTestsList: action.payload, isLoading: false };

        case FETCH_PATIENTLABTESTSLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case SET_SELECTED_PATIENT:
            return { ...state, selectedPatient: action.payload };
        
        case CLEAR_SELECTED_PATIENT:
            return {...state,selectedPatient:action.payload};

        case SET_PATIENTREGISTRATION_PAYLOAD:
            return { ...state, registrationPayload: action.payload };
        
        case CLEAR_PATIENTREGISTRATION_PAYLOAD:
            return {...state,registrationPayload:action.payload};

        case SET_SELECTEDEDIT_PATIENT:
            return { ...state, selectedEditPatient: action.payload };
        
        case CLEAR_SELECTEDEDIT_PATIENT:
            return {...state,selectedEditPatient:action.payload};

        case PATIENT_FILTER_ENABLED:
            return { ...state, patientFilter: action.payload };
        
        case PATIENT_FILTER_CLEAR:
            return {...state,patientFilter:action.payload};

         case FETCH_PATIENTSTETHESCOPE_REPORTS_REQUEST:
            return { ...state, stethLoader: true };

        case FETCH_PATIENTSTETHESCOPE_REPORTS_SUCCESS:
            return { ...state, stethReportList: action.payload, stethLoader: false };

        case FETCH_PATIENTSTETHESCOPE_REPORTS_FAILURE:
            return { ...state, error: action.payload, stethLoader: false };

        case CLEAR_FAMILY_MEMBERS:
            return{...state,familyMembers:[],familyMemberCount:0};

        default:
            return state;
    }
};
